import Together from 'together-ai';

const client = new Together({
  apiKey: import.meta.env.VITE_TOGETHER_API_KEY,
});

export const getSelectionHint = async (selectedText: string): Promise<string> => {
  try {
    const response = await client.chat.completions.create({
      model: 'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo',
      messages: [
        {
          role: 'system',
          content: 'You are a concise C# and .NET expert. Provide very brief theoretical explanations without code examples. Keep responses under 50 words.'
        },
        {
          role: 'user',
          content: `Explain this concept briefly: "${selectedText}"`
        }
      ],
      temperature: 0.3,
      max_tokens: 100
    });

    return response.choices[0]?.message?.content || 'No hint available';
  } catch (error) {
    console.error('Error getting hint:', error);
    return 'Unable to generate hint at the moment.';
  }
}; 